import { Text, CardContainer, constants, InfoPill } from '@adc/ui-adc'
import classNames from 'classnames/bind'
import hammer from '../../../../assets/hammer.svg'
import shakingHands from '../../../../assets/shaking-hands.svg'
import checkMark from '../../../../assets/check-mark.png'
import styles from './styles.scss'

const cx = classNames.bind(styles)
const { ColorNames } = constants
const SellingMethod = () => {
  const auctionFeatures = [
    'Maximum market exposure',
    'Competitive bidding environment',
    'You set the reserve price',
  ]

  const offerFeatures = [
    'Private sale process',
    'Pre-qualified buyers only',
    'Complete control over offers',
  ]
  return (
    <div>
      <div className={cx('landing-section', 'selling-method-container')}>
        <Text as='h2' weight='medium' style={{ fontSize: 36 }}>
          Choose Your Selling Method
        </Text>
        <Text as='p' size='large' style={{ maxWidth: 640, lineHeight: '28px' }}>
          In a time of uncertainty and not sure who to trust, Auction.com
          provides you a path to real offers from real buyers.
        </Text>
        <div className={cx('cards-container')}>
          <CardContainer
            className={cx('selling-method-card')}
            borderColor={ColorNames.InfoLight}
            borderRadius='medium'
            borderStyle='line'
            borderRadiusCorners='all'
            style={{
              background: 'linear-gradient(90deg, #F0FBFE 0%, #FFF 100%)',
            }}
          >
            <div className={cx('card-content')}>
              <div className={cx('card-header')}>
                <div className={cx('card-icon')}>
                  <img src={hammer} />
                </div>
                <Text
                  style={{ lineHeight: '32px' }}
                  size='huge'
                  weight='heavy'
                  color={constants.ColorNames.Black}
                >
                  Auction
                </Text>
              </div>
              <Text className={cx('card-description')}>
                {`Competitive bidding drives maximum value. Set your reserve
                price and let buyers compete.`}
              </Text>
              <ul className={cx('features-list')}>
                {auctionFeatures.map((feature, index) => (
                  <li key={index} className={cx('feature-item')}>
                    <img src={checkMark} />
                    <Text as='span'>{feature}</Text>
                  </li>
                ))}
              </ul>
              <InfoPill
                className={cx('card-button', 'auction-info-button')}
                content='Most Popular'
                fontWeight='bold'
              />
            </div>
          </CardContainer>
          <CardContainer
            className={cx('selling-method-card')}
            borderColor={ColorNames.InfoLight}
            borderRadius='medium'
            borderStyle='line'
            borderRadiusCorners='all'
            style={{
              background: 'linear-gradient(90deg, #F9FAFB 0%, #FFF 100%)',
            }}
          >
            <div className={cx('card-content')}>
              <div className={cx('card-header')}>
                <div className={cx('card-icon')}>
                  <img src={shakingHands} />
                </div>
                <Text
                  style={{ lineHeight: '32px' }}
                  size='huge'
                  weight='heavy'
                  color={constants.ColorNames.Black}
                >
                  Offer
                </Text>
              </div>
              <Text as='p' className={cx('card-description')}>
                {`Private sale process with pre-qualified buyers. More control, less
               public exposure.`}
              </Text>
              <ul className={cx('features-list')}>
                {offerFeatures.map((feature, index) => (
                  <li key={index} className={cx('feature-item')}>
                    <img src={checkMark} />
                    <Text as='span'>{feature}</Text>
                  </li>
                ))}
              </ul>
              <InfoPill
                className={cx('card-button', 'offer-info-button')}
                content='More Privacy'
                fontWeight='bold'
              />
            </div>
          </CardContainer>
        </div>
      </div>
    </div>
  )
}

export default SellingMethod
